import Vue from 'vue'
import Vuex from 'vuex'
import modulePaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'
import DashboardResource from "@/store/DashboardResource";
import Statistic from "@/store/Statistic";

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        DashboardResource,
        ...modulePaths,
        Statistic,
    }
})